module.exports = __webpack_public_path__ + "media/images/premium/premium_top-b220def74565875a643d328516378943.png";